import PICKUPS from "../../consts/PICKUPS";
import PickupType from "../../enums/PickupType";
import Game from "../Game";
import GameCore from "../GameCore";
import PickupGroup from "./PickupGroup";

export default class BasePickup extends Phaser.Physics.Arcade.Sprite {
  private _isConsumed: boolean = false;
  SetValue(value: number) {
    this.value = value;
  }
  private static DEFAULT_SPEED = 250;
  radius: number;
  speed: any;
  goToPlayer: boolean;
  time: number;
  originPos: Phaser.Math.Vector2;
  currentDirection: Phaser.Math.Vector2;
  value: number;
  isStationary: boolean;
  owner: null;
  isCullable: boolean;
  isTeleportOnCull: boolean;
  pool: PickupGroup;
  itemType: PickupType;
  vacuumTween: Phaser.Tweens.Tween | null;
  private previousX: number = 0;
  private previousY: number = 0;
  constructor(
    group: PickupGroup,
    x: number,
    y: number,
    pickupType: PickupType,
    texture: string
  ) {
    super(group.scene, x, y, texture);
    this.radius = 10;
    this.speed = BasePickup.DEFAULT_SPEED;
    this.goToPlayer = false;
    this.time = 0;
    this.currentDirection = new Phaser.Math.Vector2(0, 0);
    this.value = 0;
    this.isStationary = false;
    this.owner = null;
    this.isCullable = true;
    this.isTeleportOnCull = false;
    this.pool = group;
    this.itemType = pickupType;
    const itemData = PICKUPS[pickupType];
    this.value = itemData.value;
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.setScale(GameCore.PixelScale);
    if (this.body) {
      this.body.setCircle(this.radius);
    }
    this.originPos = new Phaser.Math.Vector2(this.x, this.y);
    this.vacuumTween = null;
  }
  OnTeleportOnCull() {}
  Init(x = -1000, y = -1000) {
    this.setPosition(x, y);
    this.OnRecycle();
  }
  OnRecycle() {
    this.setActive(true);
    this.setVisible(true);
    this.setTexture(this.texture.key);
    this.Body.enable = true;
    this.goToPlayer = false;
    this.speed = BasePickup.DEFAULT_SPEED;
    this.previousX = this.x;
    this.previousY = this.y;
    this._isConsumed = false;
  }

  DeSpawn() {
    this.setActive(false);
    this.setVisible(false);
    this.Body.enable = false;
    this.setVelocity(0);
    this.anims.stop();
    this.pool.Return(this);
    if (this.vacuumTween) {
      this.vacuumTween.destroy();
      this.vacuumTween = null;
    }
  }

  GetTaken() {
    // Guard against double-consume due to simultaneous overlaps or late callbacks
    if (this._isConsumed) {
      return;
    }
    this._isConsumed = true;
    this.DeSpawn();
    PICKUPS[this.itemType].pickedupAmount += 1;
  }

  Update() {
    // Check if position changed significantly and update spatial grid
    const positionChanged =
      Math.abs(this.x - this.previousX) > 5 ||
      Math.abs(this.y - this.previousY) > 5;

    if (positionChanged) {
      this.pool.updatePickupPosition(this, this.x, this.y);
      this.previousX = this.x;
      this.previousY = this.y;
    }

    if (this.goToPlayer && !this.isStationary) {
      this.GoToPlayer();
    }
  }
  GoToPlayer() {
    (this.currentDirection.x = Game.Core.Player.x - this.x),
      (this.currentDirection.y = Game.Core.Player.y - 8 - this.y);
    this.currentDirection.normalize();
    this.setVelocity(
      this.speed * this.currentDirection.x * this.time,
      this.speed * this.currentDirection.y * this.time
    );
    this.speed++;
  }

  Vacuum() {
    if (!this.goToPlayer) {
      this.time = -1;
      this.vacuumTween = this.scene.tweens.add({
        targets: this,
        time: 1,
        duration: 500,
        ease: "Linear",
      });
      this.goToPlayer = true;
      return false;
    } else {
      return true;
    }
  }

  SetSeenItem(...arg) {
    // TODO:
  }

  /**
   * Handle pickup when max size is being enforced
   * Base implementation just culls the pickup
   * Can be overridden by subclasses for special behavior (e.g., gem consolidation)
   */
  handleMaxSizeEnforcement(allPickupsOfSameType: BasePickup[]): void {
    // Default behavior: just remove the pickup
    this.DeSpawn();
  }

  get Body() {
    return this.body as Phaser.Physics.Arcade.Body;
  }
}
